import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { type LegacySiteHistoryLabels } from '../../generics/LegacySitePrimitives.js'
import { cableId, type CableId } from './Cable.js'
import { legacySiteId, type LegacySiteId } from './LegacySite.js'
import {
  legacySiteCableHistoryId,
  type LegacySiteCableHistoryId,
} from './LegacySiteCableHistory.js'

/** Represents the view public.legacy_site_cable_history_view_ */
export default interface LegacySiteCableHistoryViewTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<LegacySiteCableHistoryId, never, never>

  /** Database type: pg_catalog.int4 */
  siteId: ColumnType<LegacySiteId, never, never>

  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.bool */
  sdm: ColumnType<boolean | null, never, never>

  /** Database type: pg_catalog.bool */
  idm: ColumnType<boolean | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  startedAt: ColumnType<Date, never, never>

  /** Database type: pg_catalog.timestamptz */
  endedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.int4[] */
  decode: ColumnType<number[] | null, never, never>

  /** Database type: pg_catalog.text */
  dataType: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.jsonb */
  labels: ColumnType<LegacySiteHistoryLabels | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  lastCalibration: ColumnType<Date, never, never>
}

export type LegacySiteCableHistoryView =
  Selectable<LegacySiteCableHistoryViewTable>

export const legacySiteCableHistoryView = z.object({
  id: legacySiteCableHistoryId,
  siteId: legacySiteId,
  cableId: cableId,
  cableSerial: z.number().nullable().optional(),
  sdm: z.boolean().nullable().optional(),
  idm: z.boolean().nullable().optional(),
  startedAt: z.coerce.date(),
  endedAt: z.coerce.date().nullable().optional(),
  decode: z.number().nullable().optional(),
  dataType: z.string().nullable().optional(),
  labels: z.unknown().nullable().optional(),
  lastCalibration: z.coerce.date(),
}) as unknown as z.Schema<LegacySiteCableHistoryView>
